"use client";

import { productsSchema } from "../../../lib/types/schema/subscription/productSchema";
import type { UseRequestQueryProps } from "../../../request/hooks/useRequestQuery";
import { useRequestQuery } from "../../../request/hooks/useRequestQuery";
import { keyPlans } from "./keyProducts";

export const useRequestProducts = (
  props: Partial<UseRequestQueryProps> = {},
) => {
  return {
    query: useRequestQuery({
      ...props,
      queryFnRequestProps: {
        schema: productsSchema,
        urlBackendPath: "/products/plans",
      },
      queryKey: keyPlans(),
    }),
  };
};
